<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { Carousel, Slide } from "vue-carousel";
import ItemsApi from "@/services/items-api";

export default {
  page: {
    title: "Catalogue",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,Carousel,Slide
  },
  
  watch: {
  '$route': {
          immediate: true,
          deep: true, 
          handler(route) {
            this.reference = route.params.refItem;
            this.sectionName = route.params.sectionName;

            this.findItems();

          }
      },
  },



  data() {
    return {

      selectedItem:null,
      showItemsSpinner:false,
      pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},

      selectedPaperType: null,
      selectedPaperColor: null,
      requestedPaperTypeUnavailableMessage: null,
      reference:null,
      selectedTypes: [],
      selectedCategory:null,

    };
  },
  mounted() {
    this.equalizeAllCardsTitle();
  },
  updated() {
    this.equalizeAllCardsTitle();
  },
  methods: {
    equalizeAllCardsTitle() {
      this.$nextTick(() => {
        const titles = this.$el.querySelectorAll('.card-title-fixed');
        if (!titles.length) return;

        titles.forEach(t => {
          t.style.minHeight = 'auto';
          t.style.minWidth = 'auto';
        });

        let maxHeight = 0;
        let maxWidth = 0;

        titles.forEach(t => {
          if (t.offsetHeight > maxHeight) maxHeight = t.offsetHeight;
          if (t.offsetWidth > maxWidth) maxWidth = t.offsetWidth;
        });

        titles.forEach(t => {
          t.style.minHeight = maxHeight + 'px';
          t.style.minWidth = maxWidth + 'px';
        });
      });
    },

    setVisitItem(){
        const isCatalogScreen = 1
        ItemsApi.setVisitItem(this.selectedItem.id ,isCatalogScreen)
    },

    selectPaperType(paperType){
      this.selectedPaperType = paperType;
      this.requestedPaperTypeUnavailableMessage = null;

      const unavailable = [];
      const type = paperType === 0 ? 'Kraft' : 'ingraissable';
      const otherType = paperType === 0 ? 'ingraissable' : 'Kraft';

      if (this.selectedPaperType === 0) {
        // console.log("selected is Kraft ")
        this.selectedItem.variants.forEach(variant => {
          if (this.selectedTypes.includes(variant.id) && variant.isKraft === false) {
            unavailable.push(variant.title);
          }
        });
      

      } else if (this.selectedPaperType === 1) {
        // console.log("selected is AntiGraisse ")
        this.selectedItem.variants.forEach(variant => {
          if (this.selectedTypes.includes(variant.id) && variant.isAntiGraisse === false) {
            unavailable.push(variant.title);
          }
        });
      }

      if (!unavailable || unavailable.length === 0){
         this.requestedPaperTypeUnavailableMessage = '';
         return;
      } 
      const plural = unavailable.length > 1;
      const demo = plural ? 'ces types de sacs' : 'ce type de sac';

      this.requestedPaperTypeUnavailableMessage =`<span>Le papier ${type} n’est pas disponible pour <strong>${unavailable.join(', ')}. </strong>` +
           `Le papier ${otherType} sera utilisé pour ${demo}.</span>`;
    },


      
    selectPaperColor(paperColor){
      this.selectedPaperColor = paperColor
    },

    findItems() {

    this.showItemsSpinner = true;

      ItemsApi.findItems(this.pagemodel.currentPage, this.pagemodel.perPage, false,this.reference, this.sectionName ) .then(itemsList => {
            if(itemsList){
              this.selectedItem = itemsList.list[0]                   
              if(this.selectedItem && !this.selectedItem.supportedAntiGraisse){
                this.selectPaperType(0)
              }                   
            } else {
              this.selectedItem = null
            }
          })
          .finally(() => {
              this.showItemsSpinner = false;
              this.setVisitItem()
          })
      },



    toggleSelection(typeId) {
      const index = this.selectedTypes.indexOf(typeId);
      if (index === -1) {
        this.selectedTypes.push(typeId);
      } else {
        this.selectedTypes.splice(index, 1);
      }
      this.selectPaperType(this.selectedPaperType)
    },
    changeMainImage(image) {
      this.selectedItem.mainImage = image;
    },
    hoverImage(index) {
      this.hoveredIndex = index;
    },
    
    addToCart() {
      if (this.selectedPaperType == null ||this.selectedPaperColor == null || this.selectedTypes.length === 0 ) {
        return;
      }

      const itemsToAdd = this.selectedTypes.map(element => ({ itemVariantId: element, paperType:this.selectedPaperType, paperColor: this.selectedPaperColor }));

      this.$store.dispatch('addToCart', itemsToAdd).then((cart)=>{
          const bagCode = cart?.lines?.list?.[0]?.bagDesignCode;
          if (bagCode != null && bagCode != "undefined") {
              this.$router.push({ path: "/personnalisation-produit/" + bagCode });
          }
        })
    }


  }
};
</script>

<template>
  <Layout>
    <div class="product-page-80-width">


      <div v-if="selectedItem" class="font-weight-bold text-dark text-uppercase border-bottom mt-4 pt-4" style="font-size: 1.25rem; letter-spacing: 1.5px;">
        {{ selectedItem.title }}
      </div>

      <div v-if="selectedItem" class="row mt-2 mt-lg-3 mb-5">

        <div class="col-md-5 col-lg-5 col-xl-5 text-center text-sm-left text-md-center text-lg-left  pr-md-2 mt-5 pr-0">
          <img 
            v-bind:src="'/api/image/get/' + selectedItem.mainImage"
            alt="Image produit"  
            class=" ml-1 rounded mb-2 product-image"  
            style="cursor: pointer;" 
          />

          <div class=" mb-4" >
            <Carousel :per-page="2" :per-page-custom="[[576, 6], [768, 4], [992, 6]]" wrap-around>
              <Slide v-for="(image, index) in selectedItem.images" :key="index">
                <div 
                  class="text-center text-sm-left text-md-center text-lg-left   mt-2" 
                  @click="changeMainImage(image)"
                  @mouseover="hoverImage(index)"
                  @mouseleave="hoverImage(null)"
                >
                  <img
                    class="m-1 mb-2 pb-2"
                    v-bind:src="'/api/image/get/' + image"
                    width="100"
                    height="100"
                    alt="Image produit"
                    :class="['carousel-image', { 'selected': selectedItem.mainImage === image }]"
                    style="cursor: pointer;"
                  />
                </div>
              </Slide>
            </Carousel>
          </div>
        </div>

        <div class="col-md-7 col-lg-7 col-xl-7 pl-md-2 pl-0 ">
          <div class="text-dark mt-2 mb-3 font-weight-bold">
            Référence:  <span class="text-uppercase">{{ selectedItem.ref }}</span>
          </div>

          <div class="text-justify text-dark" style="font-size: 0.95rem;"> {{selectedItem.description }}</div>

          <div class="mt-5 pt-2 border-top">
            <div class="font-weight-bold text-dark text-uppercase" style="font-size: 1.25rem; letter-spacing: 1.5px;">Types des sacs</div>
            
            <div class="row mt-3 justify-content-center justify-content-md-start g-2">
              <div 
                v-for="variant in selectedItem.variants" 
                :key="variant.id" 
                class="card mr-2 mr-sm-3 mt-2" 
                style="cursor: pointer; max-width: 190px;"
                :style="{ borderRadius: '10px', border: selectedTypes.includes(variant.id) ? '2px solid #012b95' : '1px solid #ddd' }" 
                @click="toggleSelection(variant.id)"
              >
                <div class="text-center mt-3 p-3">
                  
                  <img   v-bind:src="'/api/image/get/' + variant.mainVariantImage" style="max-height: 100px; width: auto;" />

                  <div class="font-weight-bold text-dark mt-2 card-title-fixed" style="font-size: 0.75rem; letter-spacing: 1.5px;">{{ variant.title }}</div>
                 
                  <div class="font-weight-bold text-dark text-left mt-3" style="font-size: 12px; letter-spacing: 1.1px "><span class="text-secondary" style="font-size:10px;">A partir de </span>{{ variant.minPrice}}</div>

                  <div class="font-weight-bold text-secondary text-left mt-1" style="font-size: 10px; letter-spacing: 1.1px">Min commande: {{ variant.minQuantityOrdered}} sacs</div>
                  
                </div>
              </div>
            </div> 
          </div>

          <div v-if="selectedItem && selectedItem.supportedAntiGraisse" class="font-weight-bold text-dark text-uppercase mt-5 pt-2 border-top" style="font-size: 1.25rem; letter-spacing: 1.5px;">Type de papier</div>
          <div v-if="selectedItem && selectedItem.supportedAntiGraisse" class="d-flex pt-3">
              <div class="text-left pr-md-2 ">
                <div class="mr-md-2">
                    <b-button variant="outline-primary" :class="{ selected: selectedPaperType === 0 }" class="font-weight-bold font-size-14 paperTypeButton" @click="selectPaperType(0)">
                      <div class="font-size-14 text-uppercase m-2">Sac Papier Kraft</div>
                    </b-button>

                  </div>
              </div>
              <div class=" text-left pl-md-2">
                  <div class="mt-0 ml-2">
                    <b-button variant="outline-primary" :class="{ selected: selectedPaperType === 1 }" class="font-weight-bold  font-size-14 paperTypeButton" @click="selectPaperType(1)">
                      <div class="font-size-14 text-uppercase m-2">Sac Papier Ingraissable</div>
                    </b-button>
                  </div>
              </div>
          </div>
          <div  class="col-12 mt-2 mb-4 text-danger font-size-14 pr-4 requestedPaperTypeUnavailableMessage " v-html="requestedPaperTypeUnavailableMessage"></div>
         

          <div class="font-weight-bold text-dark text-uppercase pt-2 border-top" style="font-size: 1.25rem; letter-spacing: 1.5px;">Couleur de papier</div>
          <div class="d-flex pt-3">
              <div class="text-left pr-md-2 ">
                <div class="mr-md-2">
                    <b-button variant="outline-primary" :class="{ selected: selectedPaperColor === 0 }" class="font-weight-bold font-size-14 paperTypeButton" @click="selectPaperColor(0)">
                      <div class="font-size-14 text-uppercase m-2">Papier Brun</div>
                    </b-button>


                  </div>
              </div>
              <div class=" text-left pl-md-2">
                  <div class="mt-0 ml-2">
                    <b-button variant="outline-primary" :class="{ selected: selectedPaperColor === 1 }" class="font-weight-bold  font-size-14 paperTypeButton" @click="selectPaperColor(1)">
                      <div class="font-size-14 text-uppercase m-2">Papier Blanc</div>
                    </b-button>
                  </div>
              </div>
          </div>

          <div class="row mt-2 float-right  ">
            <b-button variant="outline-primary" @click="addToCart" class="mb-4 mt-4 py-2 custom-btn-add-to-cart" :disabled="selectedTypes.length === 0 || selectedPaperType == null || selectedPaperColor == null " >
              <img :src="require('@/assets/icons/cart-plus.svg')" alt="save" class="save-svg mt-0 mr-3 pb-1" width="20" />
              <span class="font-weight-bold text-uppercase my-auto " style="font-size: 1rem;">Personnaliser</span>
            </b-button>
          </div>

        </div>



        <div class="col-12 pt-4 ">
          <div class=" pt-4">
            <div class=" mb-4">
              <div class="font-weight-bold text-dark text-uppercase mb-2" style="font-size: 1.25rem; letter-spacing: 1.5px;">
                Détails produit
              </div>
              <div v-html="selectedItem.htmlDescription" class="text-justify" style="font-size: 0.95rem;"></div>
            </div>

            <div class="border-top pt-2 mb-4">
              <div class="font-weight-bold text-dark text-uppercase mb-2" style="font-size: 1.25rem; letter-spacing: 1.5px;">Dimensions</div>

              <div class="row" v-if="selectedItem && selectedItem.dimensions">
                <div v-for="(dimension, index) in selectedItem.dimensions.split(',')" :key="index" class="text-dark mt-2" style="font-size: 0.875rem; letter-spacing: 1.5px;">
                  {{dimension}}
                </div>
              </div>
            </div>

            <div class="border-top pt-2 mb-4" v-if="selectedItem && selectedItem.specs">
              <div class="font-weight-bold text-dark text-uppercase mb-3" style="font-size: 1.25rem; letter-spacing: 1.5px;">Specifications</div>

              <span 
                v-for="(spec, index) in selectedItem.specs.split(',')" 
                :key="index" 
                class="badge-pill px-3 py-2 mx-1 text-dark border border-secondary text-uppercase rounded-pill d-inline-block mb-2"
                style="font-weight: 600; font-size: 0.875rem;">
                {{ spec.trim() }}
              </span>
            </div>
          </div>  
        </div>


      </div>
    </div>
    


  </Layout>
</template>


<style scoped>

@media (max-width: 1200px) {
  .product-page-80-width {
        max-width: 80%; 
        margin:auto;
    }
}
.product-page-80-width {
    max-width: 90%; 
    margin:auto;
}

.card-3d {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}



.carousel-image {
  transition: transform 0.3s ease, border 0.3s ease;
}

.carousel-image.hovered {
  transform: scale(1.1);
  border-bottom: 2px solid #012b95;
}

.carousel-image.selected {
  border-bottom: 2px solid #012b95;
  /*transform: scale(1.1); */
}

.carousel-image:hover {
  transform: scale(1.1);
  border-bottom: 2px solid #012b95;
}


.requestedPaperTypeUnavailableMessage {
  min-height: 65px;
}

@media (min-width: 576px) {
  .requestedPaperTypeUnavailableMessage {
    min-height: 25px;
  }
}
@media (min-width: 768px) {
  .requestedPaperTypeUnavailableMessage {
    min-height: 45px;
  }
}

@media (max-width: 576px) {
  .product-image {
    width: 330px; 
    height:  330px; 
  }
}
@media (min-width: 576px) and (max-width: 768px) {
  .product-image {
    width: auto; 
    height:  500px; 
  }
}
@media (min-width: 768px) and (max-width: 800px) {
  .product-image {
    width: auto; 
    height:  350px; 
  }
}
@media (min-width: 800px) and (max-width: 992px) {
  .product-image {
    width: auto; 
    height:  400px; 
  }
}
@media (min-width: 992px) and (max-width: 1200px)  {
  .product-image {
    width: auto ;
    height: 450px ;
  }
}
@media (min-width: 1200px) and (max-width: 2000px) {
  .product-image {
    width: auto ;
    height: 500px  ;
  }
}

@media (min-width: 2000px) {
  .product-image {
    width: auto ;
    height: 700px  ;
  }
}

.paperTypeButton{
padding: 5px 20px;
border-radius: 12px;
}

.paperTypeButton.selected {
background-color: #012b95; 
color: white;
border-color: #012b95; 
}

.custom-btn-add-to-cart {
  border-radius: 10px;
  background-color: #012b95;
  color: white;
  border: 1px solid #012b95 ;
  font-size: 0.875rem;
  transition: 0.3s ease all;
}

.custom-btn-add-to-cart:disabled {
  background-color: #7886a8 !important;
  border: 1px solid#7886a8 !important ;
  color: white !important;
  opacity: 0.7;
  cursor: not-allowed;
}
</style>